import React, { Component } from "react";
import SisanjeBradaServiceImage from "../../images/icon-service-4-70x62.png"
import SisanjeServiceImage from "../../images/icon-service-1-70x62.png"
import BradaServiceImage from "../../images/icon-service-3-70x62.png"

class BookingServiceChoiceComponent extends Component {

    render() { 
        return (  
        <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
        <div className="shell">
          <h2>Izaberite uslugu</h2>
      
          <div className="range range-50">
            <div className="cell-xs-12 cell-md-4">
              <article className="card-service-option"><img className="card-service-option-image"
                  src={SisanjeBradaServiceImage} alt="" width="70" height="62" />
                <p className="card-service-option-title">Šišanje i sređivanje brade</p>
                <div className="card-service-option-panel">
                  <span className="btn btn-xs card-service-option-control" 
                    onClick={() => this.props.onServiceChoice('sisanjebrada')}>Izaberite</span>
                </div>
              </article>
            </div>
            <div className="cell-xs-12 cell-md-4">
              <article className="card-service-option"><img className="card-service-option-image"
                  src={SisanjeServiceImage} alt="" width="70" height="62" />
                <p className="card-service-option-title">Šišanje</p>
                <div className="card-service-option-panel">
                  <span className="btn btn-xs card-service-option-control"
                   onClick={() => this.props.onServiceChoice('sisanje')}>Izaberite</span>
                </div>
              </article>
            </div>
            <div className="cell-xs-12 cell-md-4">
              <article className="card-service-option"><img className="card-service-option-image"
                  src={BradaServiceImage} alt="" width="70" height="62" />
                <p className="card-service-option-title">Sređivanje brade</p>
                <div className="card-service-option-panel">
                  <span className="btn btn-xs card-service-option-control"
                   onClick={() => this.props.onServiceChoice('brada')}>Izaberite</span>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
      );
    }
}
 
export default BookingServiceChoiceComponent;